import script from "./TheHeaderComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheHeaderComponent.vue?vue&type=script&lang=ts&setup=true"

import "./TheHeaderComponent.scss?vue&type=style&index=0&id=907687ba&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-907687ba"]])

export default __exports__